(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ufo-campaign-film"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(){
    document.querySelectorAll('[data-ufo-autoplay]').forEach(function(video){
      if(video.dataset.ready)return;video.dataset.ready='true';
      var userPaused=false, autoAction=false;
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData=navigator.connection&&navigator.connection.saveData;
      function load(){var source=video.querySelector('source[data-src]');if(source){source.src=source.dataset.src;source.removeAttribute('data-src');video.load();}}
      video.addEventListener('pause',function(){if(!autoAction&&!video.ended)userPaused=true;autoAction=false;});
      video.addEventListener('play',function(){userPaused=false;});
      video.addEventListener('pointerdown',load,{once:true});video.addEventListener('keydown',load,{once:true});
      if('IntersectionObserver' in window){
        var observer=new IntersectionObserver(function(entries){entries.forEach(function(e){
          if(e.isIntersecting){load();if(!reduced&&!saveData&&!userPaused){var promise=video.play();if(promise)promise.catch(function(){});}}
          else if(!video.paused){autoAction=true;video.pause();}
        });},{threshold:.35});observer.observe(video);
      }else{load();}
      document.addEventListener('visibilitychange',function(){if(document.hidden&&!video.paused){autoAction=true;video.pause();}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
